import React from 'react';
import { ReactComponent as FigEyeOffComponent } from './FigEyeOff.svg';

const FigEyeOff = (props) => <FigEyeOffComponent {...props} />;

export default FigEyeOff;
